import { render, staticRenderFns } from "./AddRemoveFromList.vue?vue&type=template&id=f5c23e30&"
import script from "./AddRemoveFromList.vue?vue&type=script&lang=js&"
export * from "./AddRemoveFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports